// extracted by mini-css-extract-plugin
export default {"form":"styles_form__RhQb-","footer":"styles_footer__VCRK5","spacer":"styles_spacer__tskME"};